import { setTheme } from "@ui5/webcomponents-base/dist/config/Theme.js";

/**
 * Standard SAP Horizon themes (ADR-0010/D-1, decision BR6): Morning = light, Evening = dark. No brand layer of theming
 * parameters: colours, charts and fonts are Horizon's own.
 */
export const themes = {
  morning: "sap_horizon",
  evening: "sap_horizon_dark",
} as const;

export type ThemeKey = keyof typeof themes;

export const themeKeys = Object.keys(themes) as ThemeKey[];

export function isThemeKey(value: unknown): value is ThemeKey {
  return typeof value === "string" && value in themes;
}

/** Applies a Horizon theme to every UI5 component at runtime. */
export async function applyTheme(theme: ThemeKey): Promise<void> {
  document.documentElement.dataset["theme"] = theme;
  // Native controls and the page canvas follow the theme too (as `theme-boot.js` sets them before the first paint).
  document.documentElement.style.colorScheme = theme === "evening" ? "dark" : "light";
  await setTheme(themes[theme]);
}
